import React, { useState } from 'react';
import { Typography, Input, Modal, Button, Steps, InputNumber, Slider, Switch, Form, Row, Col } from 'antd';
const { Step } = Steps;
const { Text } = Typography;

const SetupWizard = ({ visible, closeModal, formData, handleInputChange, toggleScheduleEnabled, types, days, CurrencyToggle, currencySymbol, setCurrencySymbol, setPricePerKw }) => {
    const [currentStep, setCurrentStep] = useState(0);

    const nextStep = () => setCurrentStep(current => Math.min(current + 1, types.length));
    const prevStep = () => setCurrentStep(current => Math.max(current - 1, 0));

    // Helper function to convert minutes to HH:MM format
    const formatTime = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    };

    // Helper function to convert HH:MM to minutes
    const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return (hours * 60) + minutes;
    };


    // Generate steps for each display type
    const wizardSteps = types.map(type => ({
        title: `${type.charAt(0).toUpperCase() + type.slice(1)}`,
        content: (
            <Form layout="vertical" key={type}>
                <Form.Item style={{textTransform: 'uppercase'}} label={`${type} Display Count`}>
                    <InputNumber
                        min={0}
                        max={100000}
                        value={formData.counts[type]}
                        onChange={value => handleInputChange(type, 'counts', undefined, value)}
                        style={{ width: '100%'}}
                    />
                </Form.Item>
                <Form.Item label="Brightness Level (%)" style={{textTransform: 'uppercase'}}>
                    <Slider
                        min={0}
                        max={100}
                        value={formData.brightnessLevels[type]}
                        onChange={value => handleInputChange(type, 'brightnessLevels', undefined, value)}
                    />
                </Form.Item>
                <Text style={{textTransform: 'uppercase'}}>Display On/off schedule</Text>
                {days.map(day => (
                    <Row key={day} gutter={16} style={{marginLeft: '0px', marginTop: '8px'}}>
                        <Form.Item
                                    label={`${day} Schedule`}
                                    key={day}
                                >
                                    <Switch
                                        checked={formData.schedules[type][day.toLowerCase()].enabled}
                                        onChange={checked => toggleScheduleEnabled(type, day, checked)}
                                        style={{ marginBottom: '14px', marginRight: '14px' }}
                                        checkedChildren="Display on"
                                        unCheckedChildren="Display off"
                                    />

                                    <Slider
                                        range
                                        disabled={!formData.schedules[type][day.toLowerCase()].enabled}
                                        min={0}
                                        max={1440}
                                        step={1}
                                        value={[
                                            timeToMinutes(formData.schedules[type][day.toLowerCase()].time.split('-')[0]),
                                            timeToMinutes(formData.schedules[type][day.toLowerCase()].time.split('-')[1])
                                        ]}
                                        onChange={(value) => {
                                            const newTimeRange = `${formatTime(value[0])}-${formatTime(value[1])}`;
                                            handleInputChange(type, 'schedules', day, newTimeRange, true);
                                        }}
                                        tipFormatter={value => formatTime(value)}
                                        style={{ width: '200px', display: 'inline-block' }}
                                    />

                                    <Input
                                        disabled={!formData.schedules[type][day.toLowerCase()].enabled}
                                        value={formData.schedules[type][day.toLowerCase()].time}
                                        onChange={e => handleInputChange(type, 'schedules', day, e.target.value, true)}
                                        style={{ width: 'calc(100% - 360px)', marginLeft: '14px' }}
                                    />

                                </Form.Item>
                    </Row>
                ))}
            </Form>
        )
    }));

    wizardSteps.push({
        title: "Configure Price",
        content: (
            <Form layout="vertical">
                <Row style={{ marginTop: "16px" }}>
                    <Col>
                        <Form.Item label={`Price per kWh (${currencySymbol})`}>
                            <Input
                                type="number"
                                step="0.01"
                                value={formData.pricePerKw}
                                onChange={e => setPricePerKw(parseFloat(e.target.value))}
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item label="Toggle Currency">
                            <CurrencyToggle currencySymbol={currencySymbol} setCurrencySymbol={setCurrencySymbol} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    });

    return (
        <Modal
            title="Power Consumption Wizard"
            visible={visible}
            onOk={closeModal}
            onCancel={closeModal}
            width={'960px'}
            footer={[
                <Button key="back" onClick={prevStep} disabled={currentStep === 0}>Previous</Button>,
                <Button key="next" type="primary" onClick={nextStep} disabled={currentStep >= wizardSteps.length - 1}>Next</Button>,
                <Button key="finish" type="primary" onClick={closeModal} disabled={currentStep < wizardSteps.length - 1}>Finish</Button>
            ]}
        >
            <Steps current={currentStep} direction="horizontal">
                {wizardSteps.map((step, index) => (
                    <Step key={index} title={step.title} />
                ))}
            </Steps>
            <div style={{ marginTop: 20 }}>
                {wizardSteps[currentStep].content}
            </div>
        </Modal>
    );
};

export default SetupWizard;
